import _ from "lodash";
import React from "react";
import { withRouter } from "react-router-dom";
import { labels } from "../../../../localization/labels";
import SessionStorage from "../../../../storage/SessionStorage";
import RouteUtil from "../../../../utils/RouteUtil";
import PageComponent from "../PageComponent";
import Home from "./Home";

const searchHistoryKey = "searchHistory";
const searchHistoryNumberOfElements = 5;

class HomeContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.state = this.initialState();
  }

  componentDidMount() {
    super.componentDidMount();
    const searchValue = RouteUtil.getAndDeleteHistoryLocationParameter(
      this.props,
      "searchValue",
      true
    );
    const tagValue = RouteUtil.getAndDeleteHistoryLocationParameter(
      this.props,
      "tagValue",
      true
    );
    const classificationValue = RouteUtil.getAndDeleteHistoryLocationParameter(
      this.props,
      "classificationValue",
      true
    );

    this.setState({
      searchValue: searchValue,
      tagValue: tagValue,
      classificationValue: classificationValue,
      showTable:
        searchValue !== undefined ||
        tagValue !== undefined ||
        classificationValue !== undefined,
      shouldSearch: searchValue !== undefined
    });
  }

  initialState() {
    return {
      searchValue: undefined,
      tagValue: undefined,
      classificationValue: undefined,
      showTable: false,
      shouldSearch: false,
      searchHistory: this.getSearchHistory()
    };
  }

  getSearchHistory = () => {
    const searchHistory = SessionStorage.retreive(searchHistoryKey);
    return searchHistory?.map(item => {
      return { label: item, value: item };
    });
  };

  setSearchHistory = searchValue => {
    if (searchValue) {
      const searchHistory =
        this.state.searchHistory
          ?.map(item => item.value)
          ?.filter(value => value !== searchValue) || [];
      searchHistory.push(searchValue);
      SessionStorage.persist(
        searchHistoryKey,
        _.takeRight(searchHistory, searchHistoryNumberOfElements)
      );
    }
  };

  componentDidUpdate() {
    if (this.isComponentRefresh()) {
      this.resetComponent();
    }
  }

  resetComponent() {
    RouteUtil.changeHistoryLocationParameters(
      this.props,
      [
        { parameterName: "searchValue", newValue: undefined },
        { parameterName: "tagValue", newValue: undefined },
        {
          parameterName: "classificationValue",
          newValue: undefined
        }
      ],
      true
    );
    this.setState({ ...this.initialState() });

    super.resetComponent();
  }

  onSearchChange = event => {
    this.setState({
      searchValue: event.target.value,
      shouldSearch: false
    });
  };

  getComponentTitle = () => {
    return labels.home;
  };

  beforeOnShowKnowledgeItem = () => {
    if (
      this.state.searchValue ||
      this.state.tagValue ||
      this.state.classificationValue
    ) {
      RouteUtil.changeHistoryLocationParameters(
        this.props,
        [
          { parameterName: "searchValue", newValue: this.state.searchValue },
          { parameterName: "tagValue", newValue: this.state.tagValue },
          {
            parameterName: "classificationValue",
            newValue: this.state.classificationValue
          }
        ],
        true
      );
    }
  };

  onSearch = e => {
    if (e) {
      const searchValue = this.state.searchValue;
      RouteUtil.changeHistoryLocationParameters(
        this.props,
        [{ parameterName: "searchValue", newValue: searchValue }],
        true
      );
      this.setSearchHistory(searchValue);
      this.setState({
        shouldSearch: true,
        showTable: true,
        tagValue: undefined,
        classificationValue: undefined,
        searchHistory: this.getSearchHistory()
      });
    }
  };

  onTagClick = (word, event) => {
    RouteUtil.changeHistoryLocationParameters(
      this.props,
      [{ parameterName: "tagValue", newValue: word }],
      true
    );
    this.setState({
      tagValue: word,
      searchValue: undefined,
      classificationValue: undefined,
      showTable: true
    });
  };

  onClassificationClick = (data, index) => {
    RouteUtil.changeHistoryLocationParameters(
      this.props,
      [
        {
          parameterName: "classificationValue",
          newValue: data
        }
      ],
      true
    );
    this.setState({
      classificationValue: data,
      searchValue: undefined,
      tagValue: undefined,
      showTable: true
    });
  };

  render() {
    return (
      <Home
        {...this.renderProps()}
        {...this.handlerProps()}
        searchValue={this.state.searchValue}
        onSearchChange={this.onSearchChange}
        onSearch={this.onSearch}
        onTagClick={this.onTagClick}
        onClassificationClick={this.onClassificationClick}
        selectedWord={this.state.tagValue}
        selectedClassification={this.state.classificationValue}
        showTable={this.state.showTable}
        shouldSearch={this.state.shouldSearch}
        beforeOnShowKnowledgeItem={this.beforeOnShowKnowledgeItem}
        searchHistory={this.state.searchHistory}
      />
    );
  }
}

export default withRouter(HomeContainer);
